/**
 * Locale label map and hook for tenant-level localisation.
 * Default locale: en-AU
 */

const LABEL_MAP = {
  'en-AU': {
    postcode: 'Post Code',
    suburb: 'Suburb',
    state: 'State',
    mobile_phone: 'Mobile',
    registration: 'Rego',
    tax_name: 'GST',
    tax_id: 'ABN',
  },
  'en-US': {
    postcode: 'Zip Code',
    suburb: 'City',
    state: 'State',
    mobile_phone: 'Cell Phone',
    registration: 'License Plate',
    tax_name: 'Sales Tax',
    tax_id: 'EIN',
  },
  'en-GB': {
    postcode: 'Postcode',
    suburb: 'Town',
    state: 'County',
    mobile_phone: 'Mobile',
    registration: 'Reg',
    tax_name: 'VAT',
    tax_id: 'VAT Number',
  },
  'en-NZ': {
    postcode: 'Post Code',
    suburb: 'Suburb',
    state: 'Region',
    mobile_phone: 'Mobile',
    registration: 'Rego',
    tax_name: 'GST',
    tax_id: 'IRD Number',
  },
};

const DEFAULT_LOCALE = 'en-AU';

export const SUPPORTED_LOCALES = [
  { value: 'en-AU', label: 'English (Australia)' },
  { value: 'en-US', label: 'English (United States)' },
  { value: 'en-GB', label: 'English (United Kingdom)' },
  { value: 'en-NZ', label: 'English (New Zealand)' },
];

/**
 * Returns a translation function for the given locale.
 * Usage: const t = useLocale(tenantSettings.locale);
 *        t('postcode') => "Post Code" (en-AU) or "Zip Code" (en-US)
 */
export function useLocale(locale) {
  const currentLocale = locale && LABEL_MAP[locale] ? locale : DEFAULT_LOCALE;
  const labels = LABEL_MAP[currentLocale];
  const fallback = LABEL_MAP[DEFAULT_LOCALE];

  const t = (key) => labels[key] || fallback[key] || key;

  return t;
}

export default useLocale;
